import React from "react";
import { Box } from "@mui/material";

function MapComponent() {
  return (
    <Box
      sx={{
        position: "relative",
        textAlign: "right",
        width: "100%",
        height: 500,
      }}
    >
      <Box
        sx={{
          overflow: "hidden",
          background: "none!important",
          width: "100%",
          height: "100%",
        }}
      >
      <iframe
  className="gmap_iframe"
  width="100%"
  height="100%"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14619.30826868281!2d72.6312376!3d22.9755947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e889fac6c5737%3A0xd215c8c167323681!2sSiskon%20Ventures%20Private%20Limited!5e0!3m2!1sen!2sin!4v1710805922358!5m2!1sen!2sin"
  style={{ border: 0 }}
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>
      </Box>
    </Box>
  );
}

export default MapComponent;
